export interface Guide {
  slug: string;
  title: string;
  description: string;
  readTime: string;
  category: string;
  publishedDate: string;
  categoryColor: string;
}

export const guides: Guide[] = [
  // Abril 2026 - Cluster Crescimento de Carreira
  {
    slug: 'sair-junior-sem-esperar-2-anos',
    title: 'Como Sair do Júnior Sem Esperar 2 Anos na Mesma Empresa',
    description: 'Critérios reais de promoção a pleno em dados, roadmap de 12 meses e tabela comparativa entre júnior estagnado e em aceleração.',
    readTime: '13 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'analista-para-engenheiro-dados',
    title: 'De Analista a Engenheiro de Dados: O Que Você Precisa Aprender',
    description: 'A transição mais lucrativa dentro da área de dados. Roadmap de 9-12 meses, comparativo salarial e armadilhas comuns.',
    readTime: '14 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'soft-skills-promocao-senior-dados',
    title: 'Soft Skills que Mais Pesam na Promoção para Sênior em Dados',
    description: 'As 5 soft skills decisivas para promoção a sênior em dados, com plano de 6 meses e tabela comparativa pleno vs sênior.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'caso-negocio-pedir-aumento-dados',
    title: 'Como Montar um Caso de Negócio para Pedir Aumento com Seus Dados',
    description: 'Estrutura de caso de negócio em 1 página que triplica a chance de aprovação. Exemplo real de analista pleno e tabela de quantificação.',
    readTime: '13 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'trocar-empresa-vs-promocao-dados',
    title: 'Trocar de Empresa vs Pedir Promoção: Análise com Números',
    description: 'Framework analítico com cálculo de 3 anos para decidir entre trocar de empresa ou pedir promoção em dados.',
    readTime: '13 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'autoridade-dados-sem-ser-tecnico',
    title: 'Como Construir Autoridade em Dados Sem Ser o Mais Técnico da Sala',
    description: 'Autoridade em dados não vem de técnica — vem de ser indispensável em decisão. 5 estratégias e plano de 90 dias.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  // Abril 2026 - Cluster Transição de Carreira
  {
    slug: 'marketing-para-dados',
    title: 'Marketing para Dados: Habilidades que Você Já Tem e o Que Falta Desenvolver',
    description: 'Guia prático para profissionais de marketing migrarem para dados. Skills transferíveis, roadmap de 6 meses e comparativo salarial real.',
    readTime: '14 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'financeiro-para-dados',
    title: 'Financeiro para Dados: Como o Analista Financeiro Dobra o Salário com SQL',
    description: 'Como profissionais de finanças e FP&A migram para dados aproveitando Excel e visão de negócio. Roadmap, salários e fintechs que mais contratam.',
    readTime: '14 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'ti-suporte-para-dados',
    title: 'TI de Suporte para Dados: O Caminho Mais Subestimado de Transição',
    description: 'O atalho ignorado: profissionais de help desk e suporte N1/N2 têm vantagem técnica enorme para migrar para dados. Roadmap de 4-6 meses.',
    readTime: '14 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'administracao-para-dados',
    title: 'Administração para Dados: Excel Avançado como Porta de Entrada',
    description: 'Profissionais administrativos com Excel avançado têm a porta de entrada mais natural para dados. Como migrar via Power Query, Power BI e SQL.',
    readTime: '14 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'explicar-transicao-carreira-entrevista',
    title: 'Como Explicar uma Transição de Carreira em Entrevista Sem Parecer Despreparado',
    description: 'Estrutura PEA (Passado, Evidência, Aspiração) para responder a pergunta mais decisiva da entrevista de quem está mudando para dados.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'tempo-estudo-primeiro-curriculo-dados',
    title: 'Quantos Meses de Estudo Antes do Primeiro Currículo em Dados',
    description: 'Resposta honesta sobre tempo real de transição para dados (4-12 meses), checklist mínimo para aplicar e cronograma realista.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-04-16',
    categoryColor: 'bg-primary/10 text-primary'
  },
  // Março 2026
  {
    slug: 'diversidade-ia-equipes-diversas',
    title: 'Diversidade em IA: Por que Modelos Melhores Começam com Equipes Diversas',
    description: 'Viés algorítmico, curadoria ética, Explainable AI e por que equipes diversas constroem modelos de IA mais robustos e justos.',
    readTime: '14 min',
    category: 'Carreira',
    publishedDate: '2026-03-08',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'skills-mulheres-dados',
    title: 'As Skills Técnicas e Comportamentais mais Valorizadas para Mulheres em Dados',
    description: 'O mix de competências que separa profissionais que estagnam daquelas que aceleram para posições de senioridade e liderança em 2026.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-03-08',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'mulheres-referencia-dados',
    title: '5 Mulheres Brasileiras que Você Deveria Acompanhar na Área de Dados',
    description: 'Conheça 5 mulheres brasileiras que estão moldando o futuro do setor de dados: estratégia, liderança, impacto social e transparência.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-03-08',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'sindrome-impostora-dados',
    title: 'Síndrome da Impostora em Áreas Técnicas: Como Profissionais de Dados Enfrentam Isso',
    description: 'Como profissionais de dados enfrentam a Síndrome da Impostora: growth mindset, Diário de Impacto, liderança aliada e rede de apoio.',
    readTime: '12 min',
    category: 'Carreira',
    publishedDate: '2026-03-08',
    categoryColor: 'bg-primary/10 text-primary'
  },
  // Março 2026
  {
    slug: 'mulheres-analise-dados',
    title: 'Mulheres na Análise de Dados: Panorama Atual e Oportunidades Reais',
    description: 'Panorama das mulheres na área de dados em 2026: vagas escondidas, soft skills como diferencial, transição de carreira e o papel dos aliados no mercado.',
    readTime: '15 min',
    category: 'Carreira',
    publishedDate: '2026-03-08',
    categoryColor: 'bg-primary/10 text-primary'
  },
  // Cluster Análise de Dados - Fevereiro 2026
  {
    slug: 'o-que-faz-analista-dados',
    title: 'O Que Faz um Analista de Dados? Guia Completo da Profissão 2026',
    description: 'Descubra o que faz um Analista de Dados: responsabilidades, rotina de trabalho, habilidades necessárias, salários por senioridade e como começar.',
    readTime: '18 min',
    category: 'Carreira',
    publishedDate: '2026-02-02',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'analise-dados-iniciantes',
    title: 'Análise de Dados para Iniciantes: Por Onde Começar em 2026',
    description: 'Guia completo para iniciantes em análise de dados. Roadmap de aprendizado, recursos gratuitos, projetos práticos e como conseguir a primeira vaga.',
    readTime: '20 min',
    category: 'Carreira',
    publishedDate: '2026-02-02',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'ferramentas-analise-dados',
    title: 'Ferramentas para Análise de Dados: Guia Completo 2026',
    description: 'Conheça as melhores ferramentas para análise de dados em 2026: SQL, Python, Power BI, Tableau, Excel e mais. Comparativo completo.',
    readTime: '22 min',
    category: 'Ferramentas',
    publishedDate: '2026-02-02',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'analise-dados-excel',
    title: 'Análise de Dados no Excel: Guia Prático Completo 2026',
    description: 'Aprenda análise de dados no Excel: Tabelas Dinâmicas, Power Query, funções avançadas, dashboards e quando migrar para Power BI.',
    readTime: '20 min',
    category: 'Ferramentas',
    publishedDate: '2026-02-02',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  // 7 novos guias SEO - Janeiro 2026
  {
    slug: 'analise-dados-python-2026',
    title: 'Análise de Dados com Python 2026: Guia Completo do Zero ao Avançado',
    description: 'Aprenda análise de dados com Python em 2026. Pandas, NumPy, visualização, projetos práticos e uso de IA generativa.',
    readTime: '25 min',
    category: 'Skills',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  {
    slug: 'como-aprender-power-bi',
    title: 'Como Aprender Power BI do Zero em 2026: Guia Passo a Passo',
    description: 'Aprenda Power BI do zero. Dashboard, DAX, Power Query e certificação PL-300. Análise de dados com Power BI.',
    readTime: '22 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'google-analytics-4-analistas',
    title: 'Google Analytics 4 (GA4): Guia Completo para Analistas de Dados',
    description: 'Aprenda Google Analytics 4 em 2026. Configuração, eventos, explorations, BigQuery e certificação.',
    readTime: '20 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'looker-studio-guia-completo',
    title: 'Looker Studio: O Guia Completo para Criar Dashboards Profissionais',
    description: 'Aprenda Looker Studio (Google Data Studio) do zero. Dashboards gratuitos, integração GA4 e BigQuery.',
    readTime: '18 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'aprender-tableau-2026',
    title: 'Aprender Tableau em 2026: Guia Completo para Iniciantes',
    description: 'Aprenda Tableau do zero. Visualizações, cálculos, dashboards, LOD expressions e certificações oficiais.',
    readTime: '20 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'jupyter-notebook-dados',
    title: 'Jupyter Notebook: O Ambiente Essencial para Análise de Dados',
    description: 'Aprenda Jupyter Notebook para análise de dados. Instalação, células, Markdown, visualizações e portfólio GitHub.',
    readTime: '16 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'sql-vs-mysql-vs-postgresql',
    title: 'SQL vs MySQL vs PostgreSQL: Qual Banco de Dados Aprender em 2026?',
    description: 'Entenda a diferença entre SQL, MySQL e PostgreSQL. Qual banco aprender primeiro para carreira em dados.',
    readTime: '18 min',
    category: 'Skills',
    publishedDate: '2026-01-24',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  {
    slug: 'engenheiro-ia-2026',
    title: 'Engenheiro de IA: O Cargo Mais Promissor de 2026',
    description: 'Guia completo para se tornar Engenheiro de IA. Salários de R$25-45k, stack técnico (LangChain, RAG, LLMs), roadmap de carreira e empresas contratando.',
    readTime: '22 min',
    category: 'Carreira',
    publishedDate: '2026-01-15',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'mlops-machine-learning-producao',
    title: 'MLOps: Como Colocar Machine Learning em Produção',
    description: 'Aprenda MLOps do zero ao avançado. Stack completo: MLflow, Kubeflow, Feast, BentoML. Salários de R$18-35k no Brasil.',
    readTime: '20 min',
    category: 'Arquitetura',
    publishedDate: '2026-01-15',
    categoryColor: 'bg-accent/10 text-accent'
  },
  {
    slug: 'databricks-vs-snowflake',
    title: 'Databricks vs Snowflake: Qual Plataforma Escolher?',
    description: 'Comparativo completo Databricks vs Snowflake. Lakehouse vs Data Cloud, pricing, casos de uso e certificações.',
    readTime: '18 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-15',
    categoryColor: 'bg-secondary/50 text-secondary-foreground'
  },
  {
    slug: 'prompt-engineering-profissionais-dados',
    title: 'Prompt Engineering: A Skill Essencial para Dados',
    description: 'Aprenda Prompt Engineering para dados. Técnicas: Zero-Shot, Chain-of-Thought, ReAct. Aplicações em SQL, Python e análise.',
    readTime: '16 min',
    category: 'Skills',
    publishedDate: '2026-01-15',
    categoryColor: 'bg-green-500/10 text-green-600'
  },
  {
    slug: 'data-product-manager',
    title: 'Data Product Manager: A Ponte Entre Dados e Negócios',
    description: 'Guia completo sobre Data Product Manager. Responsabilidades, skills, salários R$15-35k, transição de carreira.',
    readTime: '18 min',
    category: 'Carreira',
    publishedDate: '2026-01-15',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'o-que-e-machine-learning-dados',
    title: 'O Que é Machine Learning e Como Usar na Área de Dados',
    description: 'Entenda o que é Machine Learning, os tipos de algoritmos, aplicações práticas na área de dados e como começar. Guia completo com exemplos reais.',
    readTime: '18 min',
    category: 'Skills',
    publishedDate: '2025-12-20',
    categoryColor: 'bg-violet-500/10 text-violet-600'
  },
  {
    slug: 'chief-ai-officer-caio',
    title: 'Chief AI Officer (CAIO): O Novo Cargo que Fará Diferença nas Empresas',
    description: 'Descubra o que faz um Chief AI Officer, salários no Brasil e EUA, responsabilidades e como se preparar para esse novo cargo executivo.',
    readTime: '15 min',
    category: 'Carreira',
    publishedDate: '2025-12-20',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'data-warehouse-lake-lakehouse-mesh',
    title: 'Data Warehouse vs Data Lake vs Lakehouse vs Data Mesh: Qual a Diferença?',
    description: 'Entenda as diferenças entre Data Warehouse, Data Lake, Data Lakehouse e Data Mesh. Comparativo completo com casos de uso e tecnologias.',
    readTime: '20 min',
    category: 'Arquitetura',
    publishedDate: '2025-12-20',
    categoryColor: 'bg-sky-500/10 text-sky-600'
  },
  {
    slug: 'salario-analista-dados-brasil-2025',
    title: 'Salário de Analista de Dados no Brasil 2025: Guia Completo',
    description: 'Quanto ganha um profissional de dados no Brasil? Guia com faixas salariais por nível, região e stack tecnológica baseado em pesquisas de mercado.',
    readTime: '12 min',
    category: 'Salários',
    publishedDate: '2025-12-15',
    categoryColor: 'bg-amber-500/10 text-amber-600'
  },
  {
    slug: '7-erros-que-impedem-vaga-dados',
    title: '7 Erros Fatais Que Impedem Você de Conseguir Vaga em Dados',
    description: 'Os erros mais comuns que profissionais cometem na busca por vagas em dados, com exemplos reais e soluções práticas para cada um.',
    readTime: '10 min',
    category: 'Carreira',
    publishedDate: '2025-12-12',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'trabalho-remoto-internacional-dados',
    title: 'Trabalho Remoto Internacional em Dados: Como Ganhar em Dólar/Euro do Brasil',
    description: 'Guia completo para conseguir trabalho remoto em empresas internacionais: requisitos, melhores plataformas, negociação salarial e aspectos legais.',
    readTime: '15 min',
    category: 'Remoto',
    publishedDate: '2025-12-10',
    categoryColor: 'bg-emerald-500/10 text-emerald-600'
  },
  {
    slug: 'primeira-vaga-dados-2025',
    title: 'Como Conseguir a Primeira Vaga em Dados em 2025',
    description: 'Estratégias práticas e comprovadas para conseguir sua primeira oportunidade na área de dados, desde a preparação do portfólio até a entrevista técnica.',
    readTime: '15 min',
    category: 'Carreira',
    publishedDate: '2025-12-08',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'salarios-dados-2026',
    title: 'Guia Completo de Salários em Dados 2026',
    description: 'Descubra quanto ganham profissionais de dados no Brasil, por nível de experiência, região e especialização. Dados atualizados do mercado.',
    readTime: '12 min',
    category: 'Mercado',
    publishedDate: '2025-12-06',
    categoryColor: 'bg-green-500/10 text-green-600'
  },
  {
    slug: 'ferramentas-dados-2026',
    title: 'Top 10 Ferramentas de Dados Mais Usadas em 2026',
    description: 'As ferramentas essenciais que todo profissional de dados precisa dominar para se destacar no mercado atual.',
    readTime: '18 min',
    category: 'Ferramentas',
    publishedDate: '2025-12-04',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'transicao-carreira-dados',
    title: 'Transição de Carreira para Dados: Guia Completo',
    description: 'Passo a passo detalhado para fazer uma transição de carreira bem-sucedida para a área de dados, independente da sua formação.',
    readTime: '20 min',
    category: 'Carreira',
    publishedDate: '2025-12-02',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'certificacoes-dados-2026',
    title: 'Certificações em Dados Que Valem a Pena em 2026',
    description: 'Análise completa das principais certificações em dados, seus custos, benefícios e se realmente fazem diferença na sua carreira.',
    readTime: '16 min',
    category: 'Carreira',
    publishedDate: '2025-11-28',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'python-vs-sql',
    title: 'Python vs SQL: O Que Aprender Primeiro?',
    description: 'Comparação detalhada entre Python e SQL para iniciantes em dados, com orientações sobre qual linguagem priorizar baseado em seus objetivos.',
    readTime: '14 min',
    category: 'Skills',
    publishedDate: '2025-11-25',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  {
    slug: 'data-engineer-vs-scientist-vs-analyst',
    title: 'Data Engineer vs Data Scientist vs Data Analyst: Qual Caminho Escolher?',
    description: 'Comparação completa entre as três principais carreiras em dados: responsabilidades, salários, skills e demanda de mercado no Brasil.',
    readTime: '15 min',
    category: 'Carreira',
    publishedDate: '2025-11-22',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'entrevistas-tecnicas-dados',
    title: 'Entrevistas Técnicas em Dados: O Que Esperar e Como Se Preparar',
    description: 'Guia completo sobre processos seletivos em dados: tipos de entrevistas, perguntas mais comuns, cases e como se preparar para cada etapa.',
    readTime: '18 min',
    category: 'Carreira',
    publishedDate: '2025-11-20',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'aws-vs-azure-vs-gcp-dados',
    title: 'Cloud para Dados: AWS vs Azure vs GCP - Comparativo Completo 2025',
    description: 'Análise comparativa das três principais clouds para dados: serviços, preços, certificações e demanda no mercado brasileiro.',
    readTime: '16 min',
    category: 'Cloud',
    publishedDate: '2025-11-18',
    categoryColor: 'bg-sky-500/10 text-sky-600'
  },
  {
    slug: 'power-bi-vs-tableau-vs-looker',
    title: 'Power BI vs Tableau vs Looker: Qual Ferramenta de BI Escolher em 2025?',
    description: 'Comparação completa entre Power BI, Tableau e Looker. Preços, curva de aprendizado, integrações e demanda de mercado no Brasil.',
    readTime: '14 min',
    category: 'Ferramentas',
    publishedDate: '2025-11-15',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'soft-skills-dados-2025',
    title: 'Soft Skills Mais Valorizadas em Profissionais de Dados em 2025',
    description: 'As competências comportamentais essenciais para profissionais de dados: comunicação, pensamento crítico, colaboração e como desenvolvê-las.',
    readTime: '13 min',
    category: 'Skills',
    publishedDate: '2025-11-12',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  {
    slug: 'machine-learning-analistas-dados-2025',
    title: 'Machine Learning para Analistas de Dados 2025: Guia Prático',
    description: 'Introdução prática a Machine Learning para analistas de dados. Ferramentas AutoML, bibliotecas Python e casos de uso reais do mercado brasileiro.',
    readTime: '16 min',
    category: 'Skills',
    publishedDate: '2025-11-10',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  // 10 novos guias - Janeiro 2026
  {
    slug: 'ia-generativa-analise-dados',
    title: 'Como Usar IA Generativa na Análise de Dados',
    description: 'Guia prático de uso de ChatGPT, Claude e GitHub Copilot para análise de dados. Prompts eficientes, casos de uso reais e limitações.',
    readTime: '18 min',
    category: 'Skills',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  {
    slug: 'guia-dbt-analytics-engineering',
    title: 'Guia Completo de dbt (Data Build Tool)',
    description: 'Tudo sobre dbt: o que é, arquitetura, dbt Core vs Cloud, primeiros passos, modelos, testes e certificação. Guia prático para analytics engineers.',
    readTime: '22 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'migracao-excel-power-bi',
    title: 'Do Excel ao Power BI: Guia de Migração Completo',
    description: 'Quando e como migrar do Excel para Power BI. Diferenças práticas, curva de aprendizado, primeiros passos e DAX básico para iniciantes.',
    readTime: '16 min',
    category: 'Ferramentas',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-blue-500/10 text-blue-600'
  },
  {
    slug: 'sql-avancado-analistas',
    title: 'SQL Avançado para Analistas de Dados',
    description: 'Domine Window Functions, CTEs, subqueries e otimização de queries. 10+ exemplos práticos de SQL avançado para analistas.',
    readTime: '20 min',
    category: 'Skills',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-purple-500/10 text-purple-600'
  },
  {
    slug: 'portfolio-dados-github',
    title: 'Como Montar um Portfólio de Dados no GitHub',
    description: 'Estrutura ideal de portfólio, tipos de projetos recomendados, datasets públicos e como documentar projetos para impressionar recrutadores.',
    readTime: '15 min',
    category: 'Carreira',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'etl-pipelines-apache-spark',
    title: 'ETL e Pipelines de Dados com Apache Spark',
    description: 'Conceitos de ETL/ELT, introdução ao Apache Spark e PySpark, Databricks e orquestradores modernos como Airflow e Prefect.',
    readTime: '22 min',
    category: 'Arquitetura',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-sky-500/10 text-sky-600'
  },
  {
    slug: 'data-governance-lgpd',
    title: 'Data Governance e LGPD para Profissionais de Dados',
    description: 'Conceitos de governança de dados, LGPD na prática, anonimização, papel do DPO e ferramentas de compliance para profissionais de dados.',
    readTime: '18 min',
    category: 'Técnico',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-slate-500/10 text-slate-600'
  },
  {
    slug: 'freelancer-dados-consultoria',
    title: 'Freelancer em Dados: Como Construir uma Carreira Independente',
    description: 'Plataformas de freelance (Upwork, Toptal), precificação, contratos, nichos lucrativos e aspectos fiscais para consultores de dados no Brasil.',
    readTime: '17 min',
    category: 'Carreira',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'roadmap-data-engineer-2026',
    title: 'Roadmap: Como se Tornar Data Engineer em 2026',
    description: 'Trilha de aprendizado completa para Data Engineer: fundamentos, ferramentas obrigatórias, projetos práticos e certificações recomendadas.',
    readTime: '20 min',
    category: 'Carreira',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-primary/10 text-primary'
  },
  {
    slug: 'roadmap-data-scientist-2026',
    title: 'Roadmap: Como se Tornar Cientista de Dados em 2026',
    description: 'Trilha completa para Cientista de Dados: matemática, estatística, ML, ferramentas essenciais e como montar um portfólio competitivo.',
    readTime: '20 min',
    category: 'Carreira',
    publishedDate: '2026-01-06',
    categoryColor: 'bg-primary/10 text-primary'
  }
];

export const getRelatedGuides = (currentSlug: string, category: string, limit: number = 3): Guide[] => {
  // First, get guides from the same category (excluding current)
  const sameCategoryGuides = guides.filter(
    g => g.category === category && g.slug !== currentSlug
  );
  
  // Then get other guides if needed
  const otherGuides = guides.filter(
    g => g.category !== category && g.slug !== currentSlug
  );
  
  // Combine: prioritize same category, then fill with others
  const result = [...sameCategoryGuides, ...otherGuides].slice(0, limit);
  
  return result;
};
